export default {
    enterpriseManningVessels: [],
    enterpriseOnboardingCrews: [],
    enterpriseAshoreCrews: [],
    enterpriseCrewsRoles: [],
    enterpriseManningVesselAlerts: [],
    enterpriseCrewsAlerts: [],
    enterpriseCrewAlertSettings: [],
}
